import React, {
	useEffect,
	useState,
	useContext,
	useRef,
} from "react";
import FiberHouseApi from "../../../../../API/FiberHouseApi";
import { UserContext } from "../../../../../App";
import MapIconDisplay from "./../MapIconDisplay";
import "./MainLeadCard.scss";
import LeadData from "./LeadData";
import StringIntReq from "../../../../../Requests/StringIntReq";
import ContactButtons from "../../../../../Services/ContactButtons";
import { MapContext } from "../..";
import { CircularProgress } from "@mui/material";
import Swal from "sweetalert2";
import { useSwipeable } from "react-swipeable";
import ChangeAccountStatusModal from "./ChangeAccountStatusModal";
import TagsApi from "../../../../../API/TagsApi";
import CustomNote from "./CustomNote";
import SelectionMenu from "../../../../SuperAdmin/Tags/components/SelectionMenu";
import TagsState from "../../../../SuperAdmin/Tags/components/TagsState";

const MainLeadCard = ({
	selectedFiberHouse,
	user,
	setIndex,
  searchFiberHouses,
}) => {
	let User = useContext(UserContext);
	const {
		selectedLead,
		setSelectedLead,
		setSelectedFiberHouse,
		tags,
		setTags,
		assignedSelectedTags,
		setAssignedSelectedTags,
		searchCriteria,
		setSearchCriteria,
	} = useContext(MapContext);
	const mapContext = useContext(MapContext);
	const [loading, setLoading] = useState(true);
	const [edit, setEdit] = useState(false);

	const [mapIcon, setMapIcon] = useState(selectedFiberHouse?.mapIconId);

	const [accountStatusModal, setAccountStatusModal] = useState(false);
	const [reload, setReload] = useState(false);
	const stopRef = useRef(null);
	const [isCustomNoteOpen, setIsCustomNoteOpen] = useState(false);

	const [disabled, setDisabled] = useState(false);

	const getLead = async (id) => {
		const req = new StringIntReq();
		req.int = id ?? selectedFiberHouse?.id ?? selectedLead?.fiberHouse?.id;
		req.pagingParams.pageNumber = 1;
		req.pagingParams.pageSize = 1;
		const res = await FiberHouseApi.GetLeadByFiberHouseId(req);
		if (res?.status?.success) {
			setSelectedLead(res.data);
			setMapIcon(res.data.fiberHouse?.mapIconId);
			setLoading(false);
		}
	};

	const refPassthrough = (el) => {
		handlers.ref(el);
		stopRef.current = el;
	};
	const handlers = useSwipeable({
		onSwiped: (eventData) => {
			eventData.event.stopPropagation();
		},
		onSwiping: (eventData) => {
			eventData.event.stopPropagation();
		},
		onSwipedDown: (eventData) => {
			eventData.event.stopPropagation();
		},
	});

	useEffect(() => {
		if (selectedFiberHouse != null) {
			setLoading(true);
			console.log("reload");
			setMapIcon(selectedFiberHouse.mapIconId);
			getLead(null);
		} else {
			setIndex(-1);
		}
	}, [selectedFiberHouse, reload]);

	useEffect(() => {
		if (mapContext.boltMode) {
			let shouldDisable = true;
			if (user.userType === "SuperAdmin") {
				shouldDisable = false;
			} else {
				shouldDisable = true;
				if (
					selectedLead?.fiberHouse?.salesRepFiberHouses.some(
						(salesRep) => salesRep.salesRepId === user.id,
					)
				) {
					shouldDisable = false;
				}
			}
			setDisabled(shouldDisable);
		} else {
			setDisabled(false);
		}
	}, [mapContext.boltMode, selectedLead]);

	let contactButtons = new ContactButtons(User);

	if (loading) {
		return (
			<div
				style={{
					display: "flex",
					justifyContent: "center",
					alignItems: "center",
					height: "100%",
					width: "100%",
				}}
			>
				<CircularProgress
					size={40}
					sx={{
						color: "var(--primary-color)",
					}}
				/>
			</div>
		);
	}

	const handleAssociate = async (associateSelectedTags) => {
		const data = {
			tagIds: associateSelectedTags.map((item) => item.id),
			leadIds: [selectedLead.id],
			candidateIds: null,
		};
		const res = await TagsApi.AssociateTag(data);

		if (!res.status?.success) {
			Swal.fire({
				title: "Error!",
				text: res.status?.message || "Error Associating!",
				icon: "error",
				timer: 2000,
				showConfirmButton: false,
			});
			return;
		}

		setTags((prevTags) =>
			prevTags.map((t) => ({
				...t,
				tagEntities: [
					...t.tagEntities,
					...res.data.filter((tEntity) => tEntity.leadTagId === t.id),
				],
			})),
		);

		Swal.fire({
			title: "Success!",
			text: "Tags have been associated successfully.",
			icon: "success",
			timer: 2000,
			showConfirmButton: false,
		});
	};

	const handleDisassociate = async (selectedTagIds) => {
		const tagEntities = tags
			.filter((t) => selectedTagIds.includes(t.id))
			.reduce(
				(prev, currT) => [
					...prev,
					...currT.tagEntities.filter(
						(tEntity) => selectedLead.id === tEntity.userId,
					),
				],
				[],
			);

		const res = await Promise.all(
			tagEntities.map(({ id }) => TagsApi.DisassociateTag({ id })),
		);

		const numberOfSuccess = res.reduce(
			(prev, currRes) => (currRes.status.success ? prev + 1 : prev),
			0,
		);

		const checkThisOut = tagEntities
			.filter((_, i) => res[i].status.success)
			.reduce(
				(prev, currTEntity) => ({
					...prev,
					[currTEntity.leadTagId]: [
						...(prev[currTEntity.leadTagId] ?? []),
						currTEntity.id,
					],
				}),
				{},
			);

		setTags((prevTags) =>
			prevTags.map((t) => {
				console.log(
					t.id,
					Object.keys(checkThisOut),
					Object.keys(checkThisOut).includes(t.id.toString()),
				);
				return Object.keys(checkThisOut).includes(t.id.toString())
					? {
							...t,
							tagEntities: t.tagEntities.filter(
								(tEntity) => !checkThisOut[t.id].includes(tEntity.id),
							),
					  }
					: t;
			}),
		);

		if (numberOfSuccess === tagEntities.length) {
			Swal.fire({
				title: "Success!",
				text: `${numberOfSuccess} Tag Entit${
					numberOfSuccess > 1 ? "ies" : "y"
				} disassociated successfully.`,
				icon: "success",
				timer: 2000,
				showConfirmButton: false,
			});
		} else {
			Swal.fire({
				title: "Problem!",
				text: `${tagEntities.length - numberOfSuccess} Tag Entit${
					tagEntities.length - numberOfSuccess > 1 ? "ies" : "y"
				} faced problems.`,
				icon: "warning",
				timer: 2000,
				showConfirmButton: false,
			});
		}
	};

	return (
		<div className="MainLeadCard">
			<div ref={refPassthrough} className="overflow-x-auto">
				<div className="MainLeadCard_LeadData">
					<ChangeAccountStatusModal
						setReload={setReload}
						open={accountStatusModal}
						setOpen={setAccountStatusModal}
						customer={selectedLead?.fidiumCustomer}
					/>

					<LeadData
						mapIcon={mapIcon}
						setMapIcon={setMapIcon}
						setReload={setReload}
						fidiumCustomer={selectedLead?.fidiumCustomer}
						lead={selectedLead}
						setEdit={setEdit}
						fiberHouse={selectedFiberHouse}
						setFiberouse={setSelectedFiberHouse}
						searchFiberHouses={getLead}
            searchFiberHousesOptimized={searchFiberHouses}
						setIndex={setIndex}
						setAccountStatusModal={setAccountStatusModal}
					/>
				</div>

				<div style={{ borderRadius: "10px" }} className="p-4">
					<TagsState
						label="Leads"
						leadOrCandidateIds={[selectedLead.id]}
						onDisassociate={handleDisassociate}
						tags={tags}
					/>
					<SelectionMenu
						tags={tags}
						onButtonClick={handleAssociate}
						searchCriteria={searchCriteria}
						setSearchCriteria={setSearchCriteria}
						selectedItems={assignedSelectedTags}
						setSelectedItems={setAssignedSelectedTags}
					/>
					<CustomNote
						open={isCustomNoteOpen}
						setOpen={setIsCustomNoteOpen}
						user={user}
						setReload={setReload}
					/>

					{/* Quick Notes */}

					<div
						className="flex mt-4 pb-4 items-center w-full justify-between"
						style={{ color: "black" }}
					>
						<div
							onClick={() => {
								if (disabled) return;
								contactButtons.emailLead(selectedLead);
							}}
							className="flex items-center justify-center h-[60px] md:h-[70px] w-[60px] md:w-[70px] rounded-full p-[10px] cursor-pointer"
						>
							<img
								src="/images/contact/email.jpeg"
								alt="email"
								className="w-full h-full object-contain"
							/>
						</div>

						<div
							onClick={() => {
								if (disabled) return;
								contactButtons.callLead(selectedLead);
							}}
							className="flex items-center justify-center h-[60px] md:h-[70px] w-[60px] md:w-[70px] rounded-full p-[10px] cursor-pointer"
						>
							<img
								src="/images/contact/call.png"
								alt="call"
								className="w-full h-full object-contain"
							/>
						</div>
						<div
							onClick={() => {
								if (disabled) return;
								contactButtons.whatsappLead(selectedLead);
							}}
							className="flex items-center justify-center h-[80px] md:h-[90px] w-[80px] md:w-[90px] rounded-full p-[10px] cursor-pointer "
						>
							<img
								src="/images/contact/whatsapp.png"
								alt="whatsapp"
								className="w-full h-full object-contain"
							/>
						</div>

						<div
							onClick={() => {
								if (disabled) return;
								contactButtons.directions(selectedLead.fiberHouse.coordinates);
							}}
							className="flex items-center justify-center h-[60px] md:h-[70px] w-[60px] md:w-[70px] rounded-full p-[10px] cursor-pointer"
						>
							<img
								src="/images/contact/maps.png"
								alt="directions"
								className="w-full h-full object-contain"
							/>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default MainLeadCard;
